export var enabledLocales = ['en-US', 'es-MX', 'ar-SA', 'ar-AE', 'tr-TR', 'en', 'es-419', 'tr', 'es', 'en-IN', 'ko', 'en-GB', 'tr-tr', 'tr-Tr'];
export var DEFAULT_LOCALE = 'en-US';
export var AUTH_OPTIMIZELY_EXPERIMENT_ID = 'chrome_localisation_phase1';
export var LOCALISED_VARIATION_ID = 'Localised';
export var LANG_PREFERENCE_COOKIE = 'langPreference';